import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { showErrorMessage } from '../../notifications';

interface IUpdatePaymentMethodPayload {
  paymentMethodId: string;
}

export const updatePaymentMethod: AsyncThunk<
  void,
  IUpdatePaymentMethodPayload,
  ThunkAPI
> = createAsyncThunk(
  'accounts/updatePaymentMethod',
  async (data, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, IUpdatePaymentMethodPayload>({
        endpoint: 'accounts/update-payment',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Put
      })(data, thunk);
      return response;
    } catch (error) {
      thunk.dispatch(showErrorMessage(JSON.stringify(error)));
      return thunk.rejectWithValue(error);
    }
  }
);